import { useMemo } from 'react';
import { useEnrichmentQuestions } from './useEnrichmentQuestions';

/**
 * Returns all event unanswered enrichments that are required before accessing the event
 * @param  {Number} eventId Event ID
 * @return {array}          Questions list
 */

export function useRequiredEnrichments(eventId) {
    const questions = useEnrichmentQuestions(eventId);
    return useMemo(() => {
        return _(questions)
            .filter(q => {
                return q.question.category == 1;
            })
            .filter(question => {
                return question.question.required && !question.answer.length;
            })
            .sortBy(question => question.number)
            .value();
    }, [questions]);
}
